<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CCarousel
      arrows
      indicators
      animate
      >
        <CCarouselItem>
          <!-- carousel 1 -->
          <div>
            <img src="../../assets/img/icon/becomeatutor1.svg" />
            <br />
            <h3 class="title mt-4 ml-2 text-left">Help To Educate</h3>
            <p class="tutor-profile-rating ml-2 text-left" style="color: #FFFFFF;">
              Be a part of us and helps the younger generation with education alongside with side hustle as a tutor
            </p>
          </div> 
        </CCarouselItem>
        
        <CCarouselItem>
          <!-- carousel 2 -->
          <div>
            <img src="../../assets/img/icon/becomeatutor2.svg" />
            <br />
            <h3 class="title mt-4 ml-2 text-left">Apply in a Minute</h3>
            <p class="tutor-profile-rating ml-2 text-left" style="color: #FFFFFF;">
              Send us your resume and submit your application with a single click
            </p>
          </div> 
        </CCarouselItem>

        <CCarouselItem>
          <!-- carousel 3 -->
          <div>
            <img src="../../assets/img/icon/becomeatutor3.svg" />
            <br />
            <h3 class="title mt-4 ml-2 text-left">Wait for Approval</h3>
            <p class="tutor-profile-rating ml-2 text-left" style="color: #FFFFFF;">
              We will get back to you and schedule an interview session for your application
            </p>
          </div> 
        </CCarouselItem>
      </CCarousel>
      <br /><br />

      <CButton color="info" class="custom-btn-login-active" style="margin-bottom: -100px;" @click="GoToBasicInfo()">Register Now</CButton>
    </CContainer>

    <div class="header-top">Become a Tutor</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()"/>
    </div>
    <div style="clear: both"></div>
  </div>
</template>
<script>

export default {
  name: 'Carousels',//   
  async mounted() {},
  methods: {
    GoToBasicInfo() {
      this.$router.push("BTBasicInformation");
    },     
    GoBack() {
      this.$router.back();
    },
  },
};
</script>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
body {
  font-family: "Montserrat", sans-serif;
}

.tutor-profile-rating {
font-family: 'Montserrat';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 150%;
}

</style>